import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type btytCredType = CarrierLogisticsCredType
export const btytDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const btyt: CarrierDef<btytCredType> = {
  name: 'Best Yet Express',
  scac: 'btyt',
  ...carrierLogistics,
  engineLayers: ['documents', 'pickup', 'profinder', 'rating', 'tracking'],
  documentTypes: btytDocumentTypes,
}
